// src/components/appointments/RadiographyPreviewModal.jsx
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { downloadRadiograph as downloadRadiographService } from "../../services/radiographyService";

export default function RadiographyPreviewModal({
  previewImage,
  onClose,
  onDownload,
}) {
  if (!previewImage) return null;

  const handleDownload = () => {
    if (!previewImage) return;

    if (typeof onDownload === "function") {
      onDownload(previewImage);
      return;
    }

    if (previewImage.appointmentId) {
      downloadRadiographService(previewImage.appointmentId);
    }
  };

  return (
    <Modal
      title="Radiografie pacient"
      onClose={onClose}
      size="xl"
      showClose={true}
      contentClassName="max-w-5xl"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-center">
          <img
            src={previewImage.url}
            alt="Radiografie"
            className="max-h-[80vh] w-full object-contain rounded-xl shadow-lg"
          />
        </div>
        <div className="flex justify-end">
          <Button variant="success" size="lg" onClick={handleDownload}>
            ⬇️ Descarcă radiografia
          </Button>
        </div>
      </div>
    </Modal>
  );
}
